import React from 'react';

const ActivityBatchesPage = React.lazy(() => import('../pages/activityBatches/ActivityBatchesPage/ActivityBatchesPage'));
const ActivityBatchWizardPage = React.lazy(() => import('../pages/activityBatches/ActivityBatchWizardPage/ActivityBatchWizardPage'));
const ActivityBatchReviewPage = React.lazy(() => import('../pages/activityBatches/ActivityBatchReviewPage/ActivityBatchReviewPage'));

export const PATH_ACTIVITY_BATCHES = '/activity-batches';
export const PATH_ACTIVITY_BATCH_CREATE = '/activity-batches/create';
export const PATH_ACTIVITY_BATCH_REVIEW = '/activity-batches/:guid/review';

const PAGE_ACTIVITY_BATCHES = {
  component: ActivityBatchesPage,
  path: PATH_ACTIVITY_BATCHES,
};

const PAGE_ACTIVITY_BATCH_CREATE = {
  component: ActivityBatchWizardPage,
  path: PATH_ACTIVITY_BATCH_CREATE,
};

const PAGE_ACTIVITY_BATCH_REVIEW = {
  component: ActivityBatchReviewPage,
  path: PATH_ACTIVITY_BATCH_REVIEW,
};

export default [PAGE_ACTIVITY_BATCH_CREATE, PAGE_ACTIVITY_BATCH_REVIEW, PAGE_ACTIVITY_BATCHES];
